import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';



@Component({
  selector: 'app-edit-order-cancel-reason',
  templateUrl: './edit-order-cancel-reason.component.html',
  styles: [
  ],
})
export class EditOrderCancelReasonComponent implements OnInit {
  @Input() content: any;
  cancelReason = '';
  cancelReasonArray = [];
  editIndex = 0;
  reason = false;
  reasonExist = false;
  cancellArray = [];  

  constructor(
    public dialogRef: NgbActiveModal,
  ) { }

  ngOnInit(): void {
    this.cancelReasonArray = this.content.cancelReasonArray;
    console.log(this.cancelReasonArray);
    this.cancellArray = this.content.cancelReasonArray;
    this.editIndex = this.content.editIndex
    this.cancelReason = this.cancelReasonArray[this.editIndex]['reason']
    this.cancellArray = this.cancellArray.filter(obj => obj['reason'] != this.cancelReason);
    
  }

  updateCancelReason(cancelReason){
    const checkQuestion = obj => obj.reason === cancelReason;

    if (!this.cancellArray.some(checkQuestion)) {
      this.reasonExist =false
      this.cancelReasonArray[this.editIndex]['reason'] = this.cancelReason;
      this.dialogRef.close({ success: true });
    }else{
      this.reasonExist =true
    }
  }

  close() {
    this.dialogRef.close({ success: false });
  }
}
